import React, { useState, useContext, useRef } from 'react';
import { SearchContext } from '../Contexts';
import Facets from './Facets';
import useOutsideAlerter from '../hooks/useOutsideClick';

const FacetLists = () => {
  const { facetsLists } = useContext(SearchContext);

  return (
    <div className="advanced-search__facets-container">
      {facetsLists && facetsLists.length
        ? facetsLists.map((facetList, index) => {
            const { mainLabel, mainValue, facets } = facetList;
            const [isExpanded, setIsExpanded] = useState(false);
            const dropdownRef = useRef(null);

            useOutsideAlerter(dropdownRef, setIsExpanded);

            return (
              <div
                key={index}
                className="advanced-search__facet-container"
                aria-expanded={isExpanded}
                ref={dropdownRef}
              >
                <label
                  className="advanced-search__facet-label"
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {mainLabel}
                </label>
                <Facets
                  facets={facets}
                  facetListIndex={index}
                  mainValue={mainValue}
                />
              </div>
            );
          })
        : ''}
    </div>
  );
};

export default FacetLists;
